module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-box-year calendar-bg-white"
  }, [_c('div', {
    staticClass: "calendar-text-center",
    staticStyle: {
      "font-size": "1.4em"
    }
  }, [(!_vm.disableCalendarYearButton) ? [_c('i', {
    staticClass: "arrow fa fa-caret-left fa-lg",
    staticStyle: {
      "padding-right": "11px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.setSelectYear(-1)
      }
    }
  })] : [_c('i', {
    staticClass: "arrow fa fa-caret-left fa-lg",
    staticStyle: {
      "padding-right": "11px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })], _vm._v(" "), _c('div', {
    staticClass: "dropdown-year"
  }, [_c('hrms-dropdown-year', {
    attrs: {
      "disabled": _vm.disableCalendarYearButton,
      "minYear": 1980,
      "maxYear": 2050,
      "nowLang": "en"
    },
    model: {
      value: (_vm.selectionYear),
      callback: function($$v) {
        _vm.selectionYear = $$v
      },
      expression: "selectionYear"
    }
  })], 1), _vm._v(" "), (!_vm.disableCalendarYearButton) ? [_c('i', {
    staticClass: "arrow fa fa-caret-right fa-lg",
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.setSelectYear(1)
      }
    }
  })] : [_c('i', {
    staticClass: "arrow fa fa-caret-right fa-lg",
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-007d4304!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/calendar_year.vue
// module id = 3497
// module chunks = 1